import { Validator } from '@vista-digital/validator';
import { FilmSynopsisLength } from '../../../../types/film-synopsis-length';
import { defaultFilmThumbnailConfig, filmThumbnailConfigValidatorSchema } from '../../thumbnail/types/config';
/**
 * Default configuration options for the Film Summary component.
 */
export const defaultFilmSummaryConfig = {
    thumbnail: Object.assign(Object.assign({}, defaultFilmThumbnailConfig), { show: true }),
    customFilmActions: {
        show: false
    },
    synopsisLength: FilmSynopsisLength.Longest
};
export const filmSummaryFilmThumbnailValidator = Validator.object(Object.assign(Object.assign({}, filmThumbnailConfigValidatorSchema), { show: Validator.boolean() }));
export const filmSummaryConfigValidatorSchema = {
    thumbnail: filmSummaryFilmThumbnailValidator,
    customFilmActions: Validator.object({ show: Validator.boolean() }),
    synopsisLength: Validator.oneOf(Object.values(FilmSynopsisLength))
};
export const filmSummaryConfigValidator = Validator.object(filmSummaryConfigValidatorSchema);
//# sourceMappingURL=config.js.map